import { IFile } from 'src/app/interfaces/io/file.interface';
import { ILaunchSettings } from 'src/app/interfaces/io/launch-settings.interface';
import { DynamicAppLoaderService } from '../../dynamic-app-loader.service';
import { VfmService } from '../../io/vfm.service';
import { WindowsManagerService } from '../../os/windows-manager.service';
import { ILauncher } from './launcher.interface';
import { LocalAppLauncher } from './local-app-launcher';

export class FileByExtensionLauncher implements ILauncher {
  constructor(
    private windowsMgr: WindowsManagerService,
    private dynamicAppLoader: DynamicAppLoaderService) {
  }

  launch(file: IFile, path: string, settings?: ILaunchSettings): Promise<number> {
    const local = new LocalAppLauncher(this.windowsMgr, this.dynamicAppLoader);
    return local.launchByFormat(file, path, settings);
  }
}
